import React from 'react'
import {colors} from "../../utils/styles"

const alertInfoStyle = {
  backgroundColor: colors.white,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
  zIndex: 402,
  position: 'fixed',
  left: '50%',
  top: 310,
  marginLeft: '-226px',
  opacity: '1.0',
  width: 500
}

const alertInfoStyleMini = {
  backgroundColor: colors.white,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
  zIndex: 402,
  width: 500,
  margin: 'auto'
}

const titleStyle = {
  color: colors.mocText,
  fontWeight: 700,
  fontSize: 16,
  padding: "20px 32px 16px 32px",
  display: "flex",
  alignItems: "center",
  gap: 8
}

const bodyStyle = {
  fontSize: 14,
  fontWeight: 400,
  color: colors.mocText,
  paddingLeft: 32,
  paddingRight: 32,
  wordBreak: 'break-word'
}

const buttonContainerStyle = {
  padding: "20px 32px",
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end'
}

const okButtonStyle = {
  marginLeft: 20,
  padding: '8px 25px',
  height: 40,
  boxSizing: 'border-box'
}
const cancelButtonStyle = {padding: '8px 20px'}

export default class DigitalNotifyDialog extends React.Component {

  handleOk() {
    if (!this.clickedOk) {
      // intentionally don't use setState to change clickedOk to true to reduce chances
      // user can get a 2nd click in
      this.clickedOk = true
      this.props.okCallback()
      this.setState({})
    }
  }

  render() {
    const {
      titleText,
      titleIconSrc,
      bodyText,
      cancelCallback,
      showOk,
      showCancel,
      dialogInsideModal,
      cancelText,
      okText,
      cancelBtnCustomClass,
      okBtnCustomClass
    } = this.props
    const showOkButton = ((showOk === undefined) || showOk) && !this.clickedOk
    const notifyModalEffectClass = dialogInsideModal ? "waiting-modal-effect-inside-modal"
        : "waiting-modal-effect"
    const modalAlertInfoStyle = dialogInsideModal ? alertInfoStyleMini : alertInfoStyle

    return (<div className={notifyModalEffectClass}>
          <div style={modalAlertInfoStyle} className={"notify-dialog"}>
            <div style={titleStyle}>
              {titleIconSrc && <img src={titleIconSrc} alt={'title icon'} style={{width: 24, height: 24}}/>}
              {titleText}
            </div>
            <div style={bodyStyle}>
              {bodyText}
            </div>
            <div style={buttonContainerStyle}>
              {showCancel && <button
                  className={`${cancelBtnCustomClass || "white-button-round"} notify-btn-cancel`}
                  style={cancelButtonStyle}
                  onClick={cancelCallback}>{cancelText ? cancelText : "CANCEL"}</button>}
              {showOkButton && <button
                  className={`${okBtnCustomClass || "white-button-round"} notify-btn-ok`}
                  style={okButtonStyle}
                  onClick={this.handleOk.bind(this)}>{okText ? okText : "OK"}</button>}
              {this.clickedOk && <img alt="..." src="images/loading2.gif" style={okButtonStyle}/>}
            </div>
          </div>
        </div>
    )
  }
}